export function getTranslation(translationsStrings, language, key){

    if(translationsStrings[language] && translationsStrings[language][key]){

        return translationsStrings[language][key];

    } else return translationsStrings.en[key]

}

